// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e157f9be","500":"0a75e28f"}[chunkId] + ".chunk.js";
};